import type { SVGProps } from 'react';
import { useId } from 'react';

type Props = SVGProps<SVGSVGElement> & {
  size?: number;
};

export const Badge = ({ className, size = 27, ...props }: Props) => {
  const idSuffix = useId();
  return (
    <svg
      className={className}
      width={size}
      height={size}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 325.76 325.77"
      {...props}
    >
      <symbol id={`nw-logo-n-header-${idSuffix}`} data-testid="nw-logo-n-header">
        <path fill="none" d="M108.59 217.18h-.03.04-.01m0 0h-.03.04-.01"></path>
        <path
          fill="#00ae4d"
          d="M107.92.64a10 10 0 0 0-3.51-.64H7.15A7.15 7.15 0 0 0 0 7.15v101.44z"
        ></path>
        <path fill="none" d="M108.59 217.18h-.03.04-.01"></path>
        <path
          fill="#00ae4d"
          d="M2.09 323.67a7.13 7.13 0 0 0 5.06 2.09h94.29a7.15 7.15 0 0 0 7.15-7.15V217.18z"
        ></path>
        <path fill="#00682c" d="M217.17 108.59v216.29l.65.27 107.94-107.97z"></path>
        <path fill="none" d="M108.59 217.18h-.03.03"></path>
        <path
          fill="#8ccb32"
          d="M108.59 217.18V.88c-.21-.1-.43-.2-.65-.28L0 108.59v210a7.13 7.13 0 0 0 2.09 5.05zm217.17 0V7.15A7.15 7.15 0 0 0 318.61 0h-94.29a7.15 7.15 0 0 0-7.15 7.14v101.45zm0 0L217.82 325.12a10 10 0 0 0 3.51.64h97.29a7.15 7.15 0 0 0 7.15-7.15V217.18z"
        ></path>
        <path fill="#d0d1d3" d="M108.6 217.18h-.01.01m108.58-108.59"></path>
        <path
          fill="#00ae4d"
          d="M111.52 2.93a9.94 9.94 0 0 0-2.94-2v216.25l105.66 105.65a10 10 0 0 0 2.94 2V108.59z"
        ></path>
      </symbol>
      <use xlinkHref={`#nw-logo-n-header-${idSuffix}`} href={`#nw-logo-n-header-${idSuffix}`}></use>
    </svg>
  );
};
